<div class="case-details-compensation">
	<button (click)="showDialog($event)">Erstatningsliste</button>
</div>